/* eslint-disable eqeqeq */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { E404 } from "Layout_v1";

import { SubMenu } from './';

/**
 * Home
 */
export const Home = props => {
  let routs = SubMenu();

  return (<>
    <Switch>
      {routs.map((item, i) => {
        if (!item.component) return null;
        return <Route exact={item.exact} path={item.path} component={item.component} key={i} />
      })}
      <Route key={999} component={E404} />
    </Switch>
  </>)

}

Home.propTypes = {
  // login: PropTypes.object.isRequired,
}

export default Home;